import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

/**
 * Upload a file to `{prefix}/{docId}/{filename}` and return the storage path
 * (what gets stored on the Firestore document).
 */
export async function uploadToStorage(
  prefix: 'blog-thumbnails' | 'service-images' | 'team-photos' | 'logos',
  docId: string,
  file: File,
): Promise<{ path: string; url: string }> {
  const safe = file.name.replace(/[^\w.-]+/g, '_');
  const path = `${prefix}/${docId}/${Date.now()}_${safe}`;
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type });
  return { path, url: await getDownloadURL(r) };
}

export function storageUrlFromPath(path: string | null | undefined): string | null {
  if (!path) return null;
  const host =
    import.meta.env.VITE_EMULATOR_STORAGE_HOST && import.meta.env.VITE_USE_EMULATORS === 'true'
      ? `http://${import.meta.env.VITE_EMULATOR_STORAGE_HOST}:${import.meta.env.VITE_EMULATOR_STORAGE_PORT ?? 9199}`
      : `https://firebasestorage.googleapis.com`;
  const bucket = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
  return `${host}/v0/b/${bucket}/o/${encodeURIComponent(path)}?alt=media`;
}
